import {useCallback} from 'react'
import {useNavigate, useSearchParams} from 'react-router-dom'

export const useSearchParam = <T = string>(
  name: string,
  initialValue?: T,
  coerce?: (v: string) => T
) => {
  const [params] = useSearchParams()
  const navigate = useNavigate()

  const setValue = useCallback(
    (id?: string, options?: {replace?: boolean}) => {
      const qs = new URLSearchParams(document.location.search)
      if (id === undefined) {
        qs.delete(name)
      } else {
        qs.set(name, id)
      }
      navigate(`${document.location.pathname}?${qs}`, {
        replace: options?.replace
      })
    },
    // ignoring navigate intentionally
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [name]
  )

  const value = params.get(name)
  const coerced = coerce && value !== null ? coerce(value) : value

  return [(coerced ?? initialValue) as T, setValue] as const
}
